import { getForeground, parseColor } from '../_colorUtils';

export const ACtaBoxMixin = (superClass) => class extends superClass {
    static get observedAttributes() {
        return ['data-color'];
    }

    constructor() {
        super();
        this.refs = {
            overlay: document.createElement('span'),
            content: document.createElement('span')
        };
        this.refs.overlay.className = 'btn-overlay';
        this.refs.content.className = 'btn-content';
        while (this.childNodes.length > 0) {
            this.refs.content.appendChild(this.childNodes[0]);
        }
        this.appendChild(this.refs.overlay);
        this.appendChild(this.refs.content);

        this.setColor();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'data-color':
                this.setColor(newValue);
                break;

            default:
                break;
        }
    }

    setColor(value) {
        const colorVarName = '--theme-cta-color';
        const onColorVarName = '--theme-cta-on-color';
        this.style.removeProperty(colorVarName);
        this.style.removeProperty(onColorVarName);
        if (value !== undefined) {
            try {
                const color = parseColor(value);
                this.style.setProperty(colorVarName, `${color.r} ${color.g} ${color.b}`);
                const onColor = parseColor(getForeground(value));
                this.style.setProperty(onColorVarName, `${onColor.r} ${onColor.g} ${onColor.b}`);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
    }
};
